<template>
  <div class="bg-container page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>
    
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <!-- <van-icon name="arrow-left" color="#fff" @click="back()" /> -->
            <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
          </template>
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <img src="/img/newLogin/icon_lang.png" />
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
        
          <!-- <div class="title">{{ $t("auth.login") }}</div> -->
          <div class="logon_box">
            <img src="/img/clogo.png" />
            <div class="cc">
              {{ $t("q1") }}
            </div>
          </div>
          
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doLogin()"
              >{{$t("auth.login")}}</van-button
            >
            <div class="c_bott">
              <div class="" @click="toRegister()">
                <span>{{$t("auth.forgetpwd")}}?</span>
              </div>
              <div  class="c_ot">
                <span>{{$t("auth.no_account")}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: 'zh',
      password: this.inputValue,
      passwordType: "password",
    };
  },
  beforeMount(){
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "zh")
    }
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'zh';
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: { 
          username: this.username, 
          password: this.password,
          // lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-field__control{
  color: #e6b98a;
}
.dong_box{
  height: 100%;
  @keyframes bg-data-v-8175861c {
      0%, 100% {
        background-position-x: 0;
      }
      50% {
        background-position-x: 100%;
      }
    }
  .dong_i{
    height: 100%;
      height: 100%;
      width: auto;
      animation: bg-data-v-8175861c 20s linear infinite;
      background: url(/img/newLogin/login.jpg) no-repeat 0 0;
      background-size: auto 100%;
      height: 100%;
    
  }
}

.login {
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
  border-bottom: solid 1px transparent;
}
.bg-container .bg-wrapper{
  background: #00000082 no-repeat 0 0;
  background-size: 100% 100%;
}
.logon_box{
  text-align: center;
  .cc{
    padding-top: 30px;
    color: #ccc;
  }
}
.language{
		position: absolute;
		top: 10px;
		right: 40px;
		height: 62px;
    
		img{
			height: 70%;
		}
	}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.login .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.login .wrapper .loginForm {
  padding:20px 60px;
}
.login .wrapper .loginForm .input {
  padding: 26px 20px;
  margin-top: 40px;
  border-radius: 10px;
  text-align: center;
  // line-height: 80px;
  font-size: 30px;


  width: 100% !important;
  height: 100%;
  box-sizing: border-box;

  background: linear-gradient(120deg, #212121, #313131);
  border: 2px solid #766350;
  color: #e6b98a;
 
}

.c_bott{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  color: #bfa77c;
  font-size: 25px;
  // .c_ot{
  //   margin-top: 20px;
  // }
}
::v-deep .van-cell::after{
  display: none;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.login .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.login .wrapper .loginForm .active {
}
.login .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 80px;
  border-radius: 50px;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
</style>
